var searchData = JSON.parse(JSON.stringify(courses))
    .filter(course => course.course_type === 32)
    .flatMap(course => course.sub_courses)
    .filter(subCourse => !subCourse.name.startsWith("A Guide to"));

console.log(
  "Filtered searchData (should not include 'A Guide to'):",
  searchData.map(c => c.name)
);

var filters = { "search": "", "credit_units": [], "course_category_id": [], "cert_prep": [] };
var currentIndex = 0; // We'll move this to 20 after building initial results


function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
const processChange = debounce(() => searchInput());
function searchInput() {
  filters.search = document.getElementById('searchInput').value.toLowerCase();
  filterResult();
}


document.addEventListener('DOMContentLoaded', function () {
  buildResult(searchData);
  checkMoreCourses();
  window.addEventListener('resize', debounce(setInitialButtonText, 300));

  const courseList = document.getElementById('courseList');
  courseList.addEventListener('click', handleCourseListClick);

  document.addEventListener('variantChanged', handleVariantChange);
});


async function handleVariantChange(event) {
  const variantId = event.detail.variantId;
  const courseJsonUrl = window.variantCourseMap?.[variantId];

  if (!courseJsonUrl) {
    console.error("❌ No course JSON available for variant:", variantId);
    return;
  }

  console.log("Loading course script:", courseJsonUrl);

  try {
    // remove any old script
    const old = document.getElementById(`script-${variantId}`);
    if (old) old.remove();

    // reset state
    window.courses = null;
    searchData = [];
    document.getElementById("courseList").innerHTML = "";

    // inject new <script>
    const script = document.createElement("script");
    script.src = courseJsonUrl;
    script.id  = `script-${variantId}`;
    script.defer = true;
    document.body.appendChild(script);

    // wait for it to load or fail
    await new Promise((resolve, reject) => {
      script.onload  = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load ${courseJsonUrl}`));
    });
    console.log("✅ Course JSON script loaded successfully.");

    // now rebuild your UI
    if (Array.isArray(window.courses)) {
      searchData = window.courses
        .filter(c => c.course_type === 32)
        .flatMap(c => c.sub_courses)
        .filter(s => !s.name.startsWith("A Guide to"));
      currentIndex = 0;
      document.getElementById("courseList").innerHTML = "";
      buildResult(searchData);
      console.log("✅ Course list updated for new variant.");
    } else {
      throw new Error("window.courses not populated");
    }

  } catch (err) {
    console.error("❌ Error loading course for variant:", variantId, err);
  }
}


function buildResult(data) {
  console.log("Building course list with", data.length, "courses");

  let courseListElement = document.getElementById("courseList");
  if (!courseListElement) {
    console.error("❌ Error: courseListElement not found.");
    return;
  }

  let content = '';
  data.slice(0, 20).forEach((course, index) => {
    let fallbackIndex = data.indexOf(course);
    let courseId = `fallback-${fallbackIndex}`;

    content += `
      <div class="course-item" data-course-id="${courseId}">
        ${buildCourseHTML(course, fallbackIndex)}
      </div>
    `;
  });

  courseListElement.innerHTML = content; // Make sure the content fully resets

  let titleSpan = document.querySelector("h2.title span");
  if (titleSpan) titleSpan.innerText = searchData.length;

  initializeTabsForAllItems(); // Ensure accordions/tabs work correctly
  setInitialButtonText();
  currentIndex = 20; // Reset index to 20 after building
  checkMoreCourses();

  console.log("✅ Course list built successfully.");
}

function loadMoreCourses() {
  console.log("Load More button clicked. Current Index:", currentIndex);

  let filteredData = searchData;
  let nextIndex = currentIndex + 8;
  if (nextIndex > filteredData.length) {
    nextIndex = filteredData.length;
  }

  let newCourses = filteredData.slice(currentIndex, nextIndex);
  if (newCourses.length === 0) {
    console.log("No more courses to load.");
    checkMoreCourses();
    return;
  }

  let courseListElement = document.getElementById("courseList");

  newCourses.forEach(course => {
    let fallbackIndex = filteredData.indexOf(course);
    let courseId = `fallback-${fallbackIndex}`;

    if (!document.querySelector(`[data-course-id="${courseId}"]`)) {
      let courseItem = document.createElement("div");
      courseItem.classList.add("course-item");
      courseItem.setAttribute("data-course-id", courseId);
      courseItem.innerHTML = buildCourseHTML(course, fallbackIndex);
      courseListElement.appendChild(courseItem);
    }
  });

  currentIndex = nextIndex;
  initializeTabsForAllItems();
  setInitialButtonText();
  checkMoreCourses();

  console.log(`✅ Load More Courses: Displayed ${currentIndex} of ${searchData.length}`);
}

function checkMoreCourses() {
  var loadMoreButton = document.getElementById("loadMoreCourses");
  if (!loadMoreButton) return;

  var currentItemCount = document.querySelectorAll('.course-item').length;
  console.log(`Currently displayed: ${currentItemCount} | Total available: ${searchData.length}`);

  if (currentItemCount >= searchData.length) {
    loadMoreButton.style.display = "none";
    console.log("✅ All courses loaded. Hiding Load More button.");
  } else {
    loadMoreButton.style.display = "block";
  }
}


function buildCourseHTML(course, index) {
  return `
    <div class="top-buttons">
        <button class="show-details">Show Details</button>
        <button class="accordion">${course.name}
          <span class="credit-units">
            ${course.ce_accreditation.credit_units != null
              ? `${course.ce_accreditation.credit_units} credit unit(s)`
              : ""
            }
          </span>
        </button>
    </div>
    <div class="panel">
      ${buildTabs(course, index)}
    </div>
  `;
}

function buildTabs(course, index) {
  let tabsHTML = `<div class="tab nomob">`;

  if (course.description) {
    tabsHTML += `<button class="tablinks nomob" aria-controls="angebot-${index}-1">Course Overview</button>`;
  }
  if (course.learning_objectives_html) {
    tabsHTML += `<button class="tablinks nomob" aria-controls="angebot-${index}-2">Learning Objectives</button>`;
  }
  if (course.author_information) {
    tabsHTML += `<button class="tablinks nomob" aria-controls="angebot-${index}-3">Author Information</button>`;
  }
  if (course.course_outline_html) {
    tabsHTML += `<button class="tablinks nomob" aria-controls="angebot-${index}-4">Course Outline</button>`;
  }
  if (course.ce_accreditation.accrediting_body_name) {
    tabsHTML += `<button class="tablinks nomob" aria-controls="angebot-${index}-5">Credit Info</button>`;
  }
  tabsHTML += `</div><div class="tabcontents nomob">`;

  if (course.description) {
    tabsHTML += `<div id="angebot-${index}-1" class="tabcontent tab1">${course.description}</div>`;
  }
  if (course.learning_objectives_html) {
    tabsHTML += `<div id="angebot-${index}-2" class="tabcontent tab2" style="display: none;">${course.learning_objectives_html}</div>`;
  }
  if (course.author_information) {
    tabsHTML += `<div id="angebot-${index}-3" class="tabcontent tab3" style="display: none;">${course.author_information}</div>`;
  }
  if (course.course_outline_html) {
    tabsHTML += `<div id="angebot-${index}-4" class="tabcontent tab4" style="display: none;">${course.course_outline_html}</div>`;
  }
  if (course.ce_accreditation.accrediting_body_name) {
    tabsHTML += `
      <div id="angebot-${index}-5" class="tabcontent tab5" style="display: none;">
        <div><strong>Accrediting Body</strong>: ${course.ce_accreditation.accrediting_body_name}</div>
        ${
          course.ce_accreditation.credit_display_name
            ? `<div><strong>Credit Name</strong>: ${course.ce_accreditation.credit_display_name}<br>
               <strong>Credit Units</strong>: ${course.ce_accreditation.credit_units}
               ${course.ce_accreditation.credit_unit_display_name}</div>`
            : ''
        }
        ${
          course.ce_accreditation.course_level_accreditation_statement || course.ce_accreditation.accreditation_statement
            ? `
              <div><strong>Accreditation Statement</strong>:</div>
              ${
                course.ce_accreditation.course_level_accreditation_statement
                  ? `<div>${course.ce_accreditation.course_level_accreditation_statement}</div>`
                  : ''
              }
              ${
                course.ce_accreditation.accreditation_statement
                  ? `<div>${course.ce_accreditation.accreditation_statement}</div>`
                  : ''
              }
            `
            : ''
        }
      </div>
    `;
  }
  tabsHTML += `</div>`;

  // MOBILE TABS AND CONTENT
  tabsHTML += `<div class="tab nodesktop">`;

  if (course.description) {
    tabsHTML += `
      <button type="button" aria-controls="angebot-${index}-1" class="tablinks nodesktop">
        Course Overview <span class="indicator"></span>
      </button>
      <div id="angebot-${index}-1" class="tabcontent tab1">${course.description}</div>
    `;
  }
  if (course.learning_objectives_html) {
    tabsHTML += `
      <button type="button" aria-controls="angebot-${index}-2" class="tablinks nodesktop">
        Learning Objectives <span class="indicator"></span>
      </button>
      <div id="angebot-${index}-2" class="tabcontent tab2" style="display: none;">${course.learning_objectives_html}</div>
    `;
  }
  if (course.author_information) {
    tabsHTML += `
      <button type="button" aria-controls="angebot-${index}-3" class="tablinks nodesktop">
        Author Information <span class="indicator"></span>
      </button>
      <div id="angebot-${index}-3" class="tabcontent tab3" style="display: none;">${course.author_information}</div>
    `;
  }
  if (course.course_outline_html) {
    tabsHTML += `
      <button type="button" aria-controls="angebot-${index}-4" class="tablinks nodesktop">
        Course Outline <span class="indicator"></span>
      </button>
      <div id="angebot-${index}-4" class="tabcontent tab4" style="display: none;">${course.course_outline_html}</div>
    `;
  }
  if (course.ce_accreditation.accrediting_body_name) {
    tabsHTML += `
      <button type="button" aria-controls="angebot-${index}-5" class="tablinks nodesktop">
        Credit Info <span class="indicator"></span>
      </button>
      <div id="angebot-${index}-5" class="tabcontent tab5" style="display: none;">
        <div><strong>Accrediting Body</strong>: ${course.ce_accreditation.accrediting_body_name}</div>
        ${
          course.ce_accreditation.credit_display_name
            ? `<div><strong>Credit Name</strong>: ${course.ce_accreditation.credit_display_name}<br>
               <strong>Credit Units</strong>: ${course.ce_accreditation.credit_units} 
               ${course.ce_accreditation.credit_unit_display_name}</div>`
            : ''
        }
        ${
          course.ce_accreditation.course_level_accreditation_statement || course.ce_accreditation.accreditation_statement
            ? `
              <div><strong>Accreditation Statement</strong>:</div>
              ${
                course.ce_accreditation.course_level_accreditation_statement
                  ? `<div>${course.ce_accreditation.course_level_accreditation_statement}</div>`
                  : ''
              }
              ${
                course.ce_accreditation.accreditation_statement
                  ? `<div>${course.ce_accreditation.accreditation_statement}</div>`
                  : ''
              }
            `
            : ''
        }
      </div>
    `;
  }
  tabsHTML += `</div>`; // end .tab.nodesktop
  return tabsHTML;
}


function handleCourseListClick(event) {
  const target = event.target;
  const courseItem = target.closest('.course-item');
  if (!courseItem) return;

  if (target.closest('.show-details')) handleShowDetailsClick(courseItem);
  else if (target.closest('.accordion')) handleAccordionClick(courseItem);
  else if (target.closest('.tablinks')) handleTabClick(event, courseItem);
}

function handleShowDetailsClick(courseItem) {
  const panel = courseItem.querySelector('.panel');
  const accordionButton = courseItem.querySelector('.accordion');
  const showDetailsButton = courseItem.querySelector('.show-details');
  toggleAccordion(accordionButton, panel, showDetailsButton);
  if (isMobile()) toggleModal(courseItem);
}

function handleAccordionClick(courseItem) {
  const panel = courseItem.querySelector('.panel');
  const accordionButton = courseItem.querySelector('.accordion');
  const showDetailsButton = courseItem.querySelector('.show-details');
  toggleAccordion(accordionButton, panel, showDetailsButton);
  if (isMobile()) toggleModal(courseItem);
}

function handleTabClick(event, courseItem) {
  event.preventDefault();
  const tabLink = event.target.closest('.tablinks');
  const tabId = tabLink.getAttribute('aria-controls');
  openTab(courseItem, tabId);
}

function openTab(courseItem, tabId) {
  const tabContents = courseItem.querySelectorAll('.tabcontent');
  const tabLinks = courseItem.querySelectorAll('.tablinks');
  tabContents.forEach(tab => {
    tab.style.display = (tab.id === tabId) ? 'block' : 'none';
  });
  tabLinks.forEach(link => {
    link.classList.toggle('active', link.getAttribute('aria-controls') === tabId);
  });
  adjustTabContentHeight();
}

function toggleAccordion(accordionButton, accordionPanel, showDetailsButton) {
  const isVisible = accordionPanel.classList.contains("accordion-visible");
  accordionPanel.classList.toggle("accordion-visible", !isVisible);
  accordionButton.classList.toggle("active", !isVisible);
  showDetailsButton.textContent = isMobile() ? (isVisible ? "Details" : "Close") : (isVisible ? "Show Details" : "Hide Details");
}

function initializeTabsForAllItems() {
  const courseItems = document.querySelectorAll('.course-item');
  courseItems.forEach((courseItem) => {
    const tabContents = courseItem.querySelectorAll('.tabcontent');
    const tabLinks = courseItem.querySelectorAll('.tablinks');

    tabContents.forEach(content => content.style.display = 'none');
    tabLinks.forEach(link => link.classList.remove('active'));

    if (tabContents.length) {
      tabContents[0].style.display = 'block';
    }
    if (tabLinks.length) {
      tabLinks[0].classList.add('active');
    }
  });
}

function adjustTabContentHeight() {
  const tabContents = document.querySelectorAll(".tabcontent");
  tabContents.forEach(tabContent => {
    if (tabContent.style.display === "block") {
      tabContent.style.maxHeight = isMobile() ? "360px" : "500px";
      tabContent.style.overflowY = tabContent.scrollHeight > parseInt(tabContent.style.maxHeight) ? "scroll" : "auto";
    }
  });
}

function setInitialButtonText() {
  document.querySelectorAll(".show-details").forEach(button => {
    const panel = button.nextElementSibling;
    button.textContent = (window.innerWidth <= 799 && !panel.classList.contains("accordion-visible"))
      ? "Details"
      : "Show Details";
  });
}

function isMobile() {
  return window.innerWidth <= 799;
}

function toggleModal(courseItem) {
  const backToTopButton = document.getElementById('BackToTop');
  courseItem.classList.toggle('modal--mg');
  document.body.style.overflow = courseItem.classList.contains('modal--mg') ? 'hidden' : '';
  courseItem.style.zIndex = courseItem.classList.contains('modal--mg') ? '9999' : '';
  if (backToTopButton) {
    backToTopButton.style.zIndex = courseItem.classList.contains('modal--mg') ? '-1' : '';
  }
  if (courseItem.classList.contains('modal--mg')) {
    initializeTabsWithinModal(courseItem); // Open the first tab when the modal is shown
  }
}

function initializeTabsWithinModal(courseItem) {
  const tabLinksMobile = courseItem.querySelectorAll(".tab.nodesktop .tablinks");
  const tabContentsMobile = courseItem.querySelectorAll(".tab.nodesktop .tabcontent");

  tabContentsMobile.forEach(content => {
    content.style.display = "none";
  });
  tabLinksMobile.forEach(link => {
    link.classList.remove("active");
  });

  if (tabLinksMobile.length > 0 && tabContentsMobile.length > 0) {
    tabLinksMobile[0].classList.add("active");
    tabContentsMobile[0].style.display = "block";
    adjustTabContentHeight();
  }
}

function loadScript(url) {
  return new Promise((resolve, reject) => {
    const existingScript = document.getElementById(`script-${url}`);
    if (existingScript) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = url;
    script.id = `script-${url}`;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${url}`));

    document.body.appendChild(script);
  });
}